import { Component, inject } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { DataTableSchema } from '../../model/dynamic-data-table.model';
import { DynamicFormArray, FieldOption, Props } from '../../model/form.model';
import { ElevateBillingReportFormArray, ElevateBillingReportProps, ElevateBillingReportSearchConfig, ElevateBillingReportTableSchema } from '../../model/elevate-reports.model';
import { LAYOUT_TYPE, OptionsFetchConfig } from '../../model/common.model';
import { CommonUtils } from '../../utils/common.utils';
import { API_STATUS, ApiEnvNames, ERROR_RESPONSE, SearchConfig } from '../../model/api.model';
import { PageContainerComponent } from '../../layout/page-container/page-container.component';
import { ElevateBillingDynamicOptionSchema } from '../../model/elevate-billing.model';
import { FieldTypesForOptions } from '../../model/form-fields.model';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-elevate-billing-reports',
  standalone: true,
  imports: [PageContainerComponent],
  templateUrl: './elevate-billing-reports.component.html'
})
export class ElevateBillingReportsComponent extends BaseComponent{
  protected data = 'DealerBillingManageExceptionReportComponent';
  public dataTableSchema: DataTableSchema = structuredClone(ElevateBillingReportTableSchema);
  public filterSchema: DynamicFormArray = structuredClone(ElevateBillingReportFormArray);
  protected props: Props = ElevateBillingReportProps
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  title = "";
  commonUtils = inject(CommonUtils);
  service = inject(CommonService);
  elevateBillingDynamicOptionFields: OptionsFetchConfig = ElevateBillingDynamicOptionSchema;
  public searchConfig = ElevateBillingReportSearchConfig
  override ngOnInit() {
    super.ngOnInit();
    super.commonFunction();
    this.disableEnableButtons(true);
  }
  override  onSearchClicked = (_searchParam: SearchConfig) => {
    this.setTableLoadingState(true);
    this.resetSorting();
    const postParam = {
      ...structuredClone(this.searchConfig)
    };
    this.filterSchema['FieldsArray'].forEach(field => {
      if (field['selectedValue'] && field['selectedValue'] !== null && field['selectedValue'] !== '') {
        postParam['body'][field['fieldName']] = field['selectedValue']
      }
    });
    this.dataTableSchema.dataSource = [];
    return this.service.getDataFromDataSource(postParam, ApiEnvNames['ElevateBilling']).then(response => {
      if (response['status'] === API_STATUS['Success']) {
        if (Array.isArray(response.result)) {
          this.dataTableSchema.dataSource = response.result;
        }
      }
      this.setTableLoadingState(false);
    }).catch(err => {
      console.info(ERROR_RESPONSE['layoutErrorPrefix'], err);   
      this.setTableLoadingState(false);
    })
  };
  override updateOptions = () => {
    return this.service.getDataFromDataSource(this.elevateBillingDynamicOptionFields.searchConfig, ApiEnvNames['ElevateBilling'])?.then(response => {
      if (response['status'] === API_STATUS['Success']) {
        if (Array.isArray(response.result)) {
          const apiResult = this.fillValuesFromApi(response.result[0]);
          const fieldNames = new Set(this.elevateBillingDynamicOptionFields.fields.map(p => p.name));
          if (this.filterSchema.FieldsArray.length > 0) {
            this.filterSchema.FieldsArray.forEach(field => {
              if (FieldTypesForOptions.includes(field['fieldType']) && fieldNames.has(field['fieldName'])) {
                field['options'] = apiResult[field['fieldName']]
                field['isLoading'] = false
              }
            })
          }
        }
      }
    }).catch(err => {
      console.info(ERROR_RESPONSE['layoutErrorPrefix'], err);   
    })
  }
  fillValuesFromApi = (response: any) => {
    const result: Record<string, Array<FieldOption>> = {};
    const dropdownData = response['dropdowns']
    if (dropdownData) {
      Object.keys(dropdownData).forEach(fieldName => {
        if (!result[fieldName]) {
          result[fieldName] = []
        }
        if(dropdownData[fieldName] && dropdownData[fieldName].length>0){
          result[fieldName] = dropdownData[fieldName].map((item: string) => ({ 'fieldLabel': item, 'fieldValue': item }))
        }else{
          result[fieldName] = [];
        }
      })
    }
    return result;
  }
}
